import { isNotEmpty } from "@neru/utils";
import * as R from "ramda";
import type { ReactNode } from "react";

import { Icon } from "../Icon";
import { Phrase } from "../Phrase/Phrase";
import { Row } from "../Row/Row";

interface BreadcrumbsProps {
  children: Array<ReactNode>;
}

export const Breadcrumbs = ({ children }: BreadcrumbsProps) => {
  const list = R.intersperse(
    <div className="mx-3 inline-flex align-middle">
      <Icon
        className="fill-primary-500"
        customSize={12}
        type="chevron-right-solid"
      />
    </div>,
    children
      .filter(isNotEmpty)
      .map((item) => <Phrase key={item?.toString()}>{item}</Phrase>),
  ).map((item) => () => item);

  return (
    <Row className="mb-4 items-center" data-testid="breadcrumbs">
      {list.map((Item, index) => (
        <Item key={index} />
      ))}
    </Row>
  );
};
